export default "__VITE_ASSET__Da6b5ipV__"